import axiosInstance from "../../axios/index";

import { SET_PROFILE_NAMES } from "../types/profileNamesTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

export const setProfileNames = (names) => ({
  type: SET_PROFILE_NAMES,
  payload: names,
});

export const fetchProfileNames = () => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(`/model/profilenames`);
      dispatch(requestSucceeded());
      const items = res.data;
      dispatch(setProfileNames(items));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
